module.exports = __webpack_public_path__ + "static/img/hiragana_large_de-compressor.017dcd1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/hiragana_large_de-compressor.gif
// module id = qf+h
// module chunks = 0